<template>
	<div style="width: 55rem; max-width: 100%;" class="m-3">
		<div class="mb-6" v-for="gatewayGroup in gateways" :key="gatewayGroup.name">
			<div class="d-flex flex-row">
				<div style=" width: 3px; height: 1.5rem; background-color: black; border-radius: 1.5px; "></div>
				<div class="ml-2 d-flex align-items-center gap-2" style="font-weight: 500">
					<span>{{gatewayGroup.name}}</span>
				</div>
			</div>
			<div class="d-flex flex-row flex-wrap mt-4">
				<el-button v-for="gww in gatewayGroup.gw" :key="gww.nameCode"
					style="width: 30%" class="d-flex flex-row align-items-center pt-3 p-2" round plain
					@click="download(gww.nameCode)">
					<img class="no-select ml-2" style="margin-bottom: 0.3rem" height="15" :src="`/static/gateways/${gww.nameCode}.png`" />
					<span class="ml-3 pb-1 pl-2">
						<span>{{gww.name}}</span>
						<span v-if="gww.isRecommended" class="ml-3 px-3 py-1 mb-1"
							style="font-size: 85%; background: #3485ff;background: linear-gradient(90deg,rgba(52, 133, 255, 1) 35%, rgba(0, 212, 255, 1) 100%); color: #fff; border-radius: 50px;">Recommended</span>
					</span>
				</el-button>
			</div>
		</div>
	</div>
</template>

<script>
//Lib
import { mapState } from "vuex";
import axios from "axios";

// Constant
import { HOST_URL, PRE_FIX_ROUTE, RENTAL_ROUTE } from "@/constant/routeApi";

export default {
	data() {
		return {
			gateways: [
					{
						name: "Global",
						gw: [
							{
								nameCode: "AP-SOUTHEAST-1",
								domain: "rdpgw8.gpuhub.net",
								name: "Global 1",
								country: "Global",
								gatewayHostname: "rdpgw8.gpuhub.net",
								isUseRemoteAddress: false,
								isRecommended: true,
							},
							// {
							// 	nameCode: "AP-NORTHEAST-2",
							// 	domain: "rdpgw8.gpuhub.net",
							// 	name: "Global 2",
							// 	country: "Global",
							// 	gatewayHostname: "rdpgw7.gpuhub.net",
							// 	isUseRemoteAddress: false,
							// 	isRecommended: true,
							// }
						]
					},
          /*
					{
						name: "America - Latin",
						gw: [							
							{
								nameCode: "US-EAST-1",
								domain: "rdpgw3.gpuhub.net",
								name: "N.Virginia",
								country: "UnitedStates",
								gatewayHostname: "rdpgw3.gpuhub.net",
								isUseRemoteAddress: false,
							},
							{
								nameCode: "US-WEST-1",
								domain: "rdpgw5.gpuhub.net",
								name: "N.California",
								country: "UnitedStates",
								gatewayHostname: "rdpgw5.gpuhub.net",
								isUseRemoteAddress: false
							},
						]
					},
					{
						name: "Europe",
						gw: [							
							{
								nameCode: "EU-CENTRAL-1",
								domain: "rdpgw1.gpuhub.net",
								name: "Frankfurt",
								country: "Germany",
								gatewayHostname: "rdpgw1.gpuhub.net",
								isUseRemoteAddress: false
							},
							{
								nameCode: "EU-WEST-1",
								domain: "rdpgw4.gpuhub.net",
								name: "Ireland",
								country: "Ireland",
								gatewayHostname: "rdpgw4.gpuhub.net",
								isUseRemoteAddress: false
							},
						]
					},
          */
					{
						name: "Asia - Pacific",
						gw: [
							{
								nameCode: "AP-NORTHEAST-2",
								domain: "rdpgw7.gpuhub.net",
								name: "Seoul",
								country: "Korea",
								gatewayHostname: "rdpgw7.gpuhub.net",
								isUseRemoteAddress: false
							},
							{
								nameCode: "VIETNAM",
								domain: "58.186.81.70",
								name: "Vietnam",
								country: "Vietnam",
								gatewayHostname: "",
								isUseRemoteAddress: true
							}
						]
					},
				],
			qualityList: {
				normal: 1,
				optimizePerformance: 2,
			},

			request: {
				quality: 1,
			},
		};
	},

	computed: {
		...mapState({
			user: (state) => state.auth.user,
		}),
		downloadFileName() {
			return `${this.targetImage.id}_${this.removeVietnameseTones(
				this.targetImage.name
			).replaceAll(" ", "_")}_${this.user.username}.rdp`;
		},
	},

	props: {
		targetImage: {
			type: Object,
			default: null,
		},
	},

	methods: {
		//#region Remove Vietnamese tones
		removeVietnameseTones(str) {
			str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
			str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
			str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i");
			str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
			str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
			str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
			str = str.replace(/đ/g, "d");
			str = str.replace(/À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ằ|Ắ|Ặ|Ẳ|Ẵ/g, "A");
			str = str.replace(/È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ/g, "E");
			str = str.replace(/Ì|Í|Ị|Ỉ|Ĩ/g, "I");
			str = str.replace(/Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ/g, "O");
			str = str.replace(/Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ/g, "U");
			str = str.replace(/Ỳ|Ý|Ỵ|Ỷ|Ỹ/g, "Y");
			str = str.replace(/Đ/g, "D");
			// Some system encode vietnamese combining accent as individual utf-8 characters
			// Một vài bộ encode coi các dấu mũ, dấu chữ như một kí tự riêng biệt nên thêm hai dòng này
			str = str.replace(/\u0300|\u0301|\u0303|\u0309|\u0323/g, ""); // ̀ ́ ̃ ̉ ̣  huyền, sắc, ngã, hỏi, nặng
			str = str.replace(/\u02C6|\u0306|\u031B/g, ""); // ˆ ̆ ̛  Â, Ê, Ă, Ơ, Ư
			// Remove extra spaces
			// Bỏ các khoảng trắng liền nhau
			str = str.replace(/ + /g, " ");
			str = str.trim();
			// Remove punctuations
			// Bỏ dấu câu, kí tự đặc biệt
			str = str.replace(
				/!|@|%|\^|\*|\(|\)|\+|=|<|>|\?|\/|,|\.|:|;|'|"|&|#|\[|\]|~|\$|_|`|-|{|}|\||\\/g,
				" "
			);
			return str;
		},
		//#endregion

		//#region Download .rdp
		download(server) {
			this.dowloadRdpOnXhr(server);
			// window.open(
			// 	`${HOST_URL.API_URL}${PRE_FIX_ROUTE.RENTAL}${RENTAL_ROUTE.DOWNLOAD_REMOTE_DESKTOP}/${this.targetImage.id}/${server}`
			// );
			// this.$emit("processingEvent", {
			// 	event: "closeThisPopup",
			// });
		},
		dowloadRdpOnXhr(server) {
			axios({
				method: 'GET',
				url: `${HOST_URL.API_URL}${PRE_FIX_ROUTE.RENTAL}${RENTAL_ROUTE.DOWNLOAD_REMOTE_DESKTOP}/${this.targetImage.id}/${server}`,
				withCredentials: true,
				responseType: 'blob',
			})
				.then((response) => {
					const href = URL.createObjectURL(response.data);
					const a = document.createElement('a');
					a.style.display = 'none';
					a.href = href;
					a.setAttribute('download', `${this.downloadFileName}`);
					document.body.appendChild(a);
					a.click();
					window.URL.revokeObjectURL(href);
				})
				.catch((error) => {
					console.log(error);
				});
		},
		//#endregion
	},
};
</script>